import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Axios from "axios";

import { useStyles } from "../../../../Components/CSS/FilterStyle.css";
import { url } from "../../../../Config/Config";
import { years } from "../../../../Components/Data/Session";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";

class StudentFormFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      classList: [],
      facultyError: "",
      groupError: "",
      sectionError: "",
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = async () => {
    try {
      const classResponse = await Axios.get(`${url}/api/schoolclass`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (classResponse.data.classes.length !== 0) {
        this.setState({
          classList: classResponse.data.classes,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getData();
      }
    }
  };

  filterFaculty = () => {
    const facultyFilter = this.state.classList
      .filter((filter) => filter.className === this.props.data.studentClass)
      .map((filter) => filter.faculty);
    let status = facultyFilter.map((filter) => {
      return filter === null || filter === undefined ? false : true;
    });
    if (status.includes(false)) {
      return false;
    } else {
      return true;
    }
  };

  checkError = () => {
    let facultyError = "";
    let groupError = "";
    let sectionError = "";
    let status = this.filterFaculty();

    if (status) {
      if (!this.props.data.faculty) {
        facultyError = "Please Enter Faculty";
      }
    }

    if (this.props.data.faculty) {
      if (!this.props.data.group) {
        groupError = "Please select group ";
      }
    }

    if (this.props.data.section === "") {
      sectionError = "Select one of the section";
    }

    if (facultyError || groupError || sectionError) {
      this.setState({
        facultyError,
        groupError,
        sectionError,
      });
      return true;
    } else {
      this.setState({
        facultyError: "",
        groupError: "",
        sectionError: "",
      });
      return false;
    }
  };

  handleInitialSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        if (this.props.studentList) {
          const studentResponse = await Axios.get(`${url}/api/students`, {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          });
          let studentList = [];
          if (studentResponse.data.students.length !== 0) {
            studentList = studentResponse.data.students.filter((filter) => {
              return this.props.data.faculty && this.props.data.group
                ? filter.currentSession.indexOf(this.props.data.session) !==
                    -1 &&
                    filter.studentClass.indexOf(
                      this.props.data.studentClass
                    ) !== -1 &&
                    filter.faculty.indexOf(this.props.data.faculty) !== -1 &&
                    filter.group.indexOf(this.props.data.group) !== -1 &&
                    filter.section.indexOf(this.props.data.section) !== -1
                : filter.currentSession.indexOf(this.props.data.session) !==
                    -1 &&
                    filter.studentClass.indexOf(
                      this.props.data.studentClass
                    ) !== -1 &&
                    filter.section.indexOf(this.props.data.section) !== -1;
            });
          }
          this.props.handleSubmit(e, studentList);
        } else {
          this.props.handleSubmit(e);
        }
      } catch (error) {
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleInitialSubmit(e);
        }
      }
    }
  };

  render() {
    const { classes, data, handleChange } = this.props;
    const classFilter = this.state.classList.map((data) => data.className);
    const facultyFilter = this.state.classList
      .filter((filter) => filter.className === data.studentClass)
      .map((data) => (data.faculty ? data.faculty : ""));
    const groupFilter = this.state.classList
      .filter(
        (filter) =>
          filter.className === data.studentClass &&
          filter.faculty === data.faculty
      )
      .map((filter) => (filter.group ? filter.group : ""));
    const sectionFilterClass = this.state.classList
      .filter((filter) => filter.className === data.studentClass)
      .map((filter) => filter.section);
    const sectionFilter = this.state.classList
      .filter(
        (filter) =>
          filter.className === data.studentClass &&
          filter.faculty === data.faculty &&
          filter.group === data.group
      )
      .map((filter) => filter.section);
    return (
      <form onSubmit={this.handleInitialSubmit}>
        <div className={classes.fieldStyle}>
          <TextField
            name="session"
            select
            required
            fullWidth
            label="Session"
            variant="outlined"
            margin="normal"
            style={{ marginRight: 20 }}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.session}
            onChange={handleChange}
          >
            <option value="">Select Any One</option>
            <option value={years[0] + 1}>{years[0] + 1}</option>
            {years.map((year, index) => (
              <option key={index} value={year}>
                {year}
              </option>
            ))}
          </TextField>
          <TextField
            name="studentClass"
            select
            required
            fullWidth
            label="Class"
            variant="outlined"
            margin="normal"
            style={{ marginRight: 20 }}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.studentClass}
            onChange={handleChange}
          >
            <option value="">Select Any One</option>
            {classFilter
              .filter((value, index) => classFilter.indexOf(value) === index)
              .map((classData, index) => (
                <option key={index} value={classData}>
                  {classData}
                </option>
              ))}
          </TextField>
          <TextField
            name="faculty"
            select
            fullWidth
            label="Faculty"
            variant="outlined"
            margin="normal"
            error={this.state.facultyError ? true : false}
            helperText={
              this.state.facultyError
                ? this.state.facultyError
                : data.faculty
                ? null
                : facultyFilter.length === 0
                ? "Please Select Class to get faculties"
                : "No any faculty for this class"
            }
            style={{ marginRight: 20 }}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.faculty}
            onChange={handleChange}
          >
            <option value="">Select Any One</option>
            {facultyFilter
              .filter((value, index) => facultyFilter.indexOf(value) === index)
              .map((classData, index) => (
                <option key={index} value={classData}>
                  {classData}
                </option>
              ))}
          </TextField>

          <TextField
            name="group"
            select
            fullWidth
            label="Group"
            variant="outlined"
            margin="normal"
            error={this.state.groupError ? true : false}
            helperText={
              this.state.groupError
                ? this.state.groupError
                : data.group
                ? null
                : groupFilter.length === 0
                ? "Please Select Faculty to get groups"
                : "No any group for this group"
            }
            style={{ marginRight: 20 }}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.group}
            onChange={handleChange}
          >
            <option value="">Select Any One</option>
            {groupFilter
              .filter((value, index) => groupFilter.indexOf(value) === index)
              .map((group, index) => (
                <option key={index} value={group}>
                  {group}
                </option>
              ))}
          </TextField>

          <TextField
            name="section"
            select
            required
            fullWidth
            label="Section"
            variant="outlined"
            margin="normal"
            className={classes.inputWithMargin}
            style={{ marginRight: 20 }}
            error={this.state.sectionError ? true : false}
            helperText={
              this.state.sectionError
                ? this.state.sectionError
                : sectionFilter.length === 0
                ? "Please Select groups or class to get sections"
                : null
            }
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.section}
            onChange={handleChange}
          >
            <option value="selected">Select Any One</option>
            {data.faculty && data.group
              ? sectionFilter.length !== 0 &&
                sectionFilter.map((section) =>
                  section.map((data, index) => (
                    <option key={index} value={data.name}>
                      {data.name}
                    </option>
                  ))
                )
              : sectionFilterClass.length !== 0 &&
                sectionFilterClass.map((section) =>
                  section.map((data, index) => (
                    <option key={index} value={data.name}>
                      {data.name}
                    </option>
                  ))
                )}
          </TextField>
        </div>
        <br />
        {this.props.buttonLabel && (
          <Button
            type="submit"
            variant="outlined"
            color="primary"
            className={classes.buttonStyle}
          >
            {this.props.buttonLabel}
          </Button>
        )}
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    isAdmin: state.AdminReducer.isAdmin,
    role: state.AdminReducer.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(StudentFormFilter));
